import React, { Fragment, SyntheticEvent } from 'react';
import { AuthService } from '../services/AuthServices';
import { User } from '../model/Model';
import { Navigate } from 'react-router-dom';

//adding a function to the props, so this class can use a callback function to send data to the parent
interface loginProps {
  authService: AuthService;
  setUser: (user: User) => void;
}
interface loginState {
  userName: string;
  password: string;
  loginAttempted: boolean;
  loginSuccesful: boolean;
}

//creating a custon event, cause react doesn't provide a default one to handle the input changes
interface CustomEvent {
  target: HTMLInputElement;
}

export class Login extends React.Component<loginProps, loginState> {
  state: loginState = {
    userName: '',
    password: '',
    loginAttempted: false,
    loginSuccesful: false,
  };

  //one way to bind a method to a class (arrow function)
  private setUserName = (event: CustomEvent) => {
    this.setState({ userName: event.target.value });
  };

  private setPassword = (event: CustomEvent) => {
    this.setState({ password: event.target.value });
  };

  private async handleSubmit(event: SyntheticEvent) {
    event.preventDefault();
    this.setState({ loginAttempted: true });
    const result = await this.props.authService.login(
      this.state.userName,
      this.state.password,
    );
    if (result) {
      this.setState({ loginSuccesful: true });
      this.props.setUser(result);
    } else {
      this.setState({ loginSuccesful: false });
    }
  }

  render() {
    let loginMessage: any;
    if (this.state.loginAttempted) {
      if (this.state.loginSuccesful) {
        return <Navigate to="/profile" replace />; //changing the logic, so the navigate is triggered
      } else {
        loginMessage = <label>Login failed</label>;
      }
    }
    return (
      <Fragment>
        <h2>Please log in</h2>
        <form onSubmit={e => this.handleSubmit(e)}>
          <input
            value={this.state.userName}
            type="text"
            onChange={this.setUserName}
          />
          <br />
          <input
            value={this.state.password}
            type="password"
            onChange={e => this.setPassword(e)} //another way to bind a method to a class
          />
          <br />
          <button type="submit">Log in</button>
        </form>
        {loginMessage}
      </Fragment>
    );
  }
}
